import { doc } from 'firebase/firestore';
import {
  TIMELINE_DATA_SUB,
  TIMELINE_INFO_DOC_ID,
  TIMELINE_INFO_KIND,
  TIMELINE_ASSETS_SUB_LEGACY,
} from '../constants/firestoreCollections';

export { TIMELINE_DATA_SUB, TIMELINE_INFO_DOC_ID, TIMELINE_INFO_KIND };

/** Firestore path for per-capture timelineData/_info */
export function timelineInfoDocRef(db, userId, projectId, captureId) {
  return doc(
    db,
    'users',
    userId,
    'studio',
    projectId,
    'captures',
    captureId,
    TIMELINE_DATA_SUB,
    TIMELINE_INFO_DOC_ID,
  );
}

/** Map timelineData/_info doc to legacy snapshot shape for timeline UI */
export function timelineInfoToSnapshotStep(infoDoc) {
  if (!infoDoc) return null;
  const captureId = infoDoc.captureId || infoDoc.id;
  return {
    id: captureId,
    captureId,
    sceneDate: infoDoc.sceneDate ?? null,
    label: infoDoc.label ?? null,
    included: infoDoc.included !== false,
    orderIndex: infoDoc.orderIndex ?? null,
    source: infoDoc.source ?? null,
    createdAt: infoDoc.createdAt ?? null,
    updatedAt: infoDoc.updatedAt ?? null,
    _fromTimelineInfo: true,
  };
}

export function isTimelineFileDocId(docId) {
  return docId && docId !== TIMELINE_INFO_DOC_ID;
}

export const TIMELINE_ASSETS_SUB = TIMELINE_DATA_SUB;
export { TIMELINE_ASSETS_SUB_LEGACY };
